/*
    *Author:ludi
*/
import React from 'react';
import { ArrowItem } from '@beisen/chaos-ui';
import PanelArea from './PanelArea';
import transLoader from '@beisen/i18n-translation-loader';
const defaultTranslation = {
    selectHolder: '点击选择',
    required: '必填'
};
class Area extends React.Component {
    constructor(props) {
        super(props);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleConfirm = this.handleConfirm.bind(this);
        this.handleTouchTap = this.handleTouchTap.bind(this);
        this.clearData = this.clearData.bind(this);
        this.afterClose = this.afterClose.bind(this);
        this.state = {
            showPopUp: false
            ,visible: false
            ,isCancle: true
            ,selectedAreas: this.transformStrToArray(props)
        };
        this.translation = Object.assign({}, defaultTranslation, transLoader({
            selectHolder: 'fieldPlaceHolder.selectHolder',
            required: 'common.required'
        }), props.translation);
    }
    componentWillMount() {
        if(this.props.pop_type == 'searchItem') {
            this.setState({ showPopUp: true });
        }
    }
    componentWillReceiveProps(nextProps) {
        if(this.props.pop_type == 'searchItem' && nextProps.visible) {
            this.setState({ showPopUp: true });
        }
        if(nextProps.value != this.props.value) {
            this.setState({ selectedAreas: this.transformStrToArray(nextProps) ,text: nextProps.text });
        }
    }
    transformStrToArray(props) {
        let selectedAreas = [];
        let propValue = props.value + '';
        if(props.text && propValue) {
            const selectedValues = propValue.split(',');
            const displayTexts = Object.prototype.toString.call(props.text) === '[object String]' ? props.text.split(',') : props.text;
            for(let i = 0; i < selectedValues.length; i++) {
                if(selectedValues[i] != '') {
                        selectedAreas.push({
                            Id: selectedValues[i],
                            Name: displayTexts[i]
                        });
                }
            }
        }
        return selectedAreas;
    }
    handleCancel() {
        if(this.props.pop_type == 'searchItem') {
            this.props.handleCancel && this.props.handleCancel();
        }
        this.setState({
            visible: false
            ,isCancle: true
            ,selectedAreas: this.transformStrToArray(this.props)
        });
    }
    handleTouchTap() {
        this.setState({ showPopUp: true, visible: true },() => {
            this.props.onFocus && this.props.onFocus();
        });
    }
    clearData() {
        this.setState({ selectedAreas: [] });
        this.props.onChange && this.props.onChange({ text: '', value: '', 'selectedItems': [] });
    }
    handleConfirm(items) {
        let submitObj = {};
        if(items.length > 0 && items[0] !== undefined) {
             submitObj = {
                text: items[0].Name,
                value: items[0].Id
            };
            for(let i = 1; i < items.length; i++) {
                submitObj.text +=  ',' + items[i].Name;
                submitObj.value +=  ',' + items[i].Id;
            }
        }else{
            submitObj = { text: '', value: '' };
        }
        this.data = submitObj;
        if(this.props.pop_type == 'searchItem') {
            this.props.handleClosePopUp && this.props.handleClosePopUp();
            this.setState({ isCancle: false });
        }else {
            this.setState({ visible: false, isCancle: true },() => {
                this.props.onChange && this.props.onChange(submitObj);
            });
        }
    }
    afterClose() {
        if(!this.state.isCancle) {
            this.props.onChange && this.props.onChange(this.data);
            this.props.synBizData && this.props.synBizData();
        }
        this.setState({ showPopUp: false });
    }

    renderNormalPopArea() {
        const errMsg = this.props.errorMessage && this.props.errorMessage.message;
        return(
            <div className="poparea">
                <ArrowItem label={this.props.label}
                            required={this.props.required}
                            errorMsg={errMsg}
                            isReadOnly={this.props.isReadOnly}
                            onClickForm={this.handleTouchTap}
                            value={this.props.text}
                            desc={this.props.desc}
                            translation={this.translation}
                    styleTitle={this.props.styleTitle}
                />
                {this.state.showPopUp ?
                    <PanelArea
                        handleCancel={this.handleCancel}
                        handleConfirm={this.handleConfirm}
                        singleSelect={this.props.cmp_data.singleSelect}
                        selectedAreas={this.state.selectedAreas}
                        selectIds={this.props.value}
                        onClearValue={this.clearData}
                        pop_type={this.props.pop_type}
                        afterClose={this.afterClose}
                        visible={this.state.visible}
                        isFullPathFormat={this.props.cmp_data.isFullPathFormat || ''}
                        showForeignSource={this.props.cmp_data.showForeignSource}
                    /> : null}
            </div>
        );
    }
    renderSearchItemPopArea() {

        return (
            this.state.showPopUp ? <PanelArea
                handleCancel={this.handleCancel}
                handleConfirm={this.handleConfirm}
                singleSelect={this.props.cmp_data.singleSelect}
                selectedAreas={this.state.selectedAreas}
                selectIds={this.props.value}
                onClearValue={this.clearData}
                pop_type={this.props.pop_type}
                afterClose={this.afterClose}
                visible={this.props.visible}
                isFullPathFormat={this.props.cmp_data.isFullPathFormat || ''}
                showForeignSource={this.props.cmp_data.showForeignSource}
            /> : null
        );
    }
    render() {
        return this.props.pop_type == 'searchItem' ? this.renderSearchItemPopArea() :
               this.renderNormalPopArea();
    }
}
export default Area;



// WEBPACK FOOTER //
// ./src/components/Field_Components/PopArea/PopArea.js